import { useEffect, useState } from 'react';
import { useMediaQuery as useBaseMediaQuery } from 'usehooks-ts';

export const useBreakpointQuery = (query: string, ssrDefault = false) => {
  const [isClient, setIsClient] = useState(false);
  const matches = useBaseMediaQuery(query);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient ? matches : ssrDefault;
};
